<template>
  <div :class="$style.graphContainer">
    <SummaryGraphHeader
      :categories="categories"
      :item="item"
      :total="total"
      :totalText="totalText"
    />
    <SummaryGraphContent
      :categories="categories"
      :item="item"
      :total="total"
    />
  </div>
</template>

<script>

import SummaryGraphCategory from 'client/components/Graphs/SummaryGraphCategory';
import SummaryGraphContent from 'client/components/Graphs/SummaryGraphContent';
import SummaryGraphHeader from 'client/components/Graphs/SummaryGraphHeader';

export default {
  name: 'SummaryGraph',

  components: {
    SummaryGraphContent,
    SummaryGraphHeader,
  },

  props: {
    categories: {
      type: Array,
      required: true,
      validate(categories) {
        return categories.every(category => category instanceof SummaryGraphCategory);
      },
    },
    item: {
      type: String,
      required: true,
    },
    totalText: {
      type: String,
      required: true,
    },
  },

  computed: {
    total() {
      return this.categories.reduce((total, category) => total + category.qty, 0);
    },
  },
};
</script>

<style module>
@import "./css/SummaryGraph.css";
</style>
